import { Component, OnInit, ViewChild } from '@angular/core';
import { PaginationComponent } from '../common/pagination/pagination.component';
import { CommonModule, Location } from '@angular/common';
import { CabinetService } from '../services/cabinet.service';
import { ActivatedRoute } from '@angular/router';
import { FormsModule } from '@angular/forms';
// import $ from "jquery";

@Component({
  selector: 'app-cabinet-summary',
  standalone: true,
  imports: [PaginationComponent, CommonModule, FormsModule],
  templateUrl: './cabinet-summary.component.html',
  styleUrls: ['./cabinet-summary.component.scss', '../../app.component.scss']
})
export class CabinetSummaryComponent implements OnInit{
  @ViewChild(PaginationComponent) paginationView: PaginationComponent;

  public totalPages: number = 0;
  public currentPage: number = 1;
  
  public totalProducts: number = 0;

  public cabinetDetails: any = []; 
  public currentCabinetId: string = '';
  public cabinetProductSummary: any = [];
  
  public isCabinetProductSummary: boolean = false;

  public searchInput: string = "";
  public encodedSearchInput: string = "";

  public isCabinets = true;
  public isSearch = false;
  public isFilter = false;
  public isFilterResult = true;

  public loggedAtSortValue:string = "";
  public orderBy:string = "asc";

  public selectedActions = [];

  public userNamesList: any = [];
  public selectedUserNames: any = [];
  public isUserNames: boolean = false;

  constructor(public cabinetService: CabinetService, public location: Location, public route: ActivatedRoute){

  }

  ngOnInit(): void {
    this.currentCabinetId = this.route.snapshot.params['id'];
    this.getCabinetDetails();
    this.getCabinetProductSummary();
    this.getCabinetUsers();
  }

  openActionPopup(event){
    document.getElementById("action-popup").classList.toggle("active");

    event.stopPropagation()

    this.closePopupOutside("action-popup");
  }

  getCabinetDetails(){
    this.cabinetService.getCabinetDetails(this.currentCabinetId).subscribe(res => {
      if (res.data) {
        this.cabinetDetails = res.data;
      }
    });
  }
  
  getCabinetProductSummary(page: string = "", search: string = "", action: Array<string> = [], users: Array<string> = [], loggedAt: string = ""){
    this.cabinetService.getCabinetProductSummary(this.currentCabinetId, page, search, action, users, loggedAt).subscribe(res => {
      if(res.data){
        if (res.data.data.length !== 0) {
          this.totalProducts = res.data.total;
          this.totalPages = res.data.last_page;
          this.cabinetProductSummary = res.data.data;

          if (this.isSearch || this.isFilter) {
            this.isFilterResult = true;
          }else{
            this.isCabinetProductSummary = true;
          }
        }else{
          if (this.isSearch || this.isFilter) {
            this.isFilterResult = false;
          }else{
            this.isCabinetProductSummary = false;
          }

          this.totalProducts = 0;
          this.totalPages = 0;
        }
      }
    }); 
  }

  getCabinetUsers(){
    this.cabinetService.getCabinetUsers(this.currentCabinetId, "names").subscribe(res => {
      if (res.data.length !== 0) {
        this.isUserNames = true;
        this.userNamesList = res.data;
      }else{
        this.isUserNames = false;
      }
    });
  }

  onSearchSubmit(){
    if (this.searchInput !== "") {
      this.isSearch = true;
      if (this.isFilter) {
        this.selectedActions = [];
        this.selectedUserNames = [];
        this.loggedAtSortValue = "";
        this.isFilter = false;
        this.isFilterResult = true;
      }
      this.encodedSearchInput = encodeURIComponent(this.searchInput);
      if (this.currentPage > 1) {
        this.currentPage = 1;
        this.paginationView.onCurrentPageChange(this.currentPage);
      }
      this.getCabinetProductSummary("", this.encodedSearchInput);
    }
  }

  openUsersPopup(event){
    document.getElementById("users-popup").classList.toggle("active");
    event.stopPropagation()
    this.closePopupOutside("users-popup");
  }

  onUserFilterChange(event){
    if (event.target.checked) {
      this.selectedUserNames.push(event.target.value);
    }else{
      this.selectedUserNames = this.selectedUserNames.filter((element)=>{
        return element !== event.target.value;
      });
    }

    this.isFilter = true;
    this.onFilterChange();    
  }

  onActionFilterChange(event){
    if (event.target.checked) {
      this.selectedActions.push(event.target.value);
    }else{
      this.selectedActions = this.selectedActions.filter((element)=>{
        return element !== event.target.value;
      });
    }

    this.isFilter = true;
    this.onFilterChange();    
  }

  reset(event: Event){
    event.preventDefault();
    if (this.isSearch || this.isFilter) {
      this.encodedSearchInput = "";
      this.searchInput = "";
      this.selectedActions = [];
      this.selectedUserNames = [];
      this.loggedAtSortValue = "";
      this.isSearch = false;
      this.isFilter = false;
      this.isFilterResult = true;
      if (this.currentPage > 1) {
        this.currentPage = 1;
        this.paginationView.onCurrentPageChange(this.currentPage);
      } 
      this.getCabinetProductSummary("");
    }
  }

  getQueryPage($event: number){
    this.currentPage = $event;    
    this.getCabinetProductSummary(`${this.currentPage}`, this.encodedSearchInput, this.selectedActions, this.selectedUserNames, this.loggedAtSortValue);
  }

  loggedAtSort(){
    this.isFilter = true;

    if (this.loggedAtSortValue === "asc") {
      this.loggedAtSortValue = "desc";
    }else{
      this.loggedAtSortValue = this.orderBy;
    }

    this.onFilterChange();    
  }

  onFilterChange(){
    if (this.currentPage > 1) {
      this.currentPage = 1;
      this.paginationView.onCurrentPageChange(this.currentPage);
    }
    
    this.getCabinetProductSummary("", this.encodedSearchInput, this.selectedActions, this.selectedUserNames, this.loggedAtSortValue);
  }

  goBack(){
    this.location.back();
  }

  closePopupOutside(popupId: string){
    let popupDiv = document.getElementById(popupId);

    document.addEventListener('click', function(event: any) {
      if (
        popupDiv.className.includes("active") &&
        !popupDiv.contains(event.target)
      ) {
        popupDiv.classList.remove("active");
      }
    })
  }
}
